module.exports = __webpack_public_path__ + "media/images/company_logo/logo_watabewedding-41e793ccb105b086edcfec2f4b234841.jpg";